
import { computed, defineComponent, onMounted, ref } from "vue";
import ContactItem from "./ContactItemContainer.vue";
import InputCheckbox from "@/components/inputs/inputCheckbox/InputCheckbox.vue";
import { storeToRefs } from "pinia";
import {
    ContactCheckInterface,
    RecipientInterface,
} from "@/store/norms/interfaces";
import { useNormStore } from "@/store/norms";

export default defineComponent({
    name: "contactContainer",
    components: { ContactItem, InputCheckbox },
    props: {
        open: {
            type: Boolean,
            required: false,
        },
    },
    emits: ["close"],
    setup() {
        const { userRecipients, customerRecipients, editNorm } = storeToRefs(
            useNormStore()
        );
        const currentView = ref<string>("employee");
        const selectAll = ref({ employee: true, customer: true });

        const tabsNeeded = computed(() => {
            return (
                editNorm.value.notify_customers && editNorm.value.notify_users
            );
        });

        function changeCheckValue(data: ContactCheckInterface): void {
            if (currentView.value == "employee") {
                userRecipients.value[data.index].checked = data.value;
                if (!data.value) {
                    selectAll.value.employee = false;
                }
            } else {
                customerRecipients.value[data.index].checked = data.value;
                if (!data.value) {
                    selectAll.value.customer = false;
                }
            }
        }

        function selectAllRecipiens(view: string, value: boolean): void {
            if (view == "users") {
                userRecipients.value.map(
                    (recipients: RecipientInterface) =>
                        (recipients.checked = value)
                );
            } else {
                customerRecipients.value.map(
                    (recipients: RecipientInterface) =>
                        (recipients.checked = value)
                );
            }
        }

        onMounted(async () => {
            if (!editNorm.value.notify_users) {
                currentView.value = "customer";
            }
        });
        return {
            currentView,
            selectAll,
            userRecipients,
            customerRecipients,
            changeCheckValue,
            selectAllRecipiens,
            editNorm,
            tabsNeeded,
        };
    },
});
